import React from "react";
import PropTypes from "prop-types";
import Select from "react-select-latest";

/**
 * A simple wrapper around react-select that adds some classes to match the styling of Support Center,
 * plus the ability to initially display as a list.
 */
export const StyledReactSelect = ({
  initialDisplayAsList,
  noHeightLimit,
  value,
  styles = {},
  ...props
}) => {
  const displayAsList = initialDisplayAsList && !value;

  if (noHeightLimit) {
    styles.menuList = (base) => ({
      ...base,
      maxHeight: "inherit"
    });
  }
  // these settings alter the style of the react-select element
  // to hide the search box, and display the full list of options
  // inline with the document.
  if (displayAsList) {
    // position the dropdown menu inline
    // with the document instead of floating
    styles.menu = (base) => ({
      ...base,
      position: "relative",
      zIndex: "inherit"
    });
    // hide the main control so that only the list is displayed
    styles.control = (base) => ({
      ...base,
      display: "none !important"
    });
  }

  return (
    <Select
      classNames={{
        container: () => "react-select-container",
        control: (state) =>
          state.isFocused ? "form-control form-control-focus" : "form-control",
        valueContainer: () => "value-container",
        menu: () => "form-menu",
        option: (state) => {
          state.isSelected ? "form-option form-option-selected" : "form-option";
        },
        ...props.classNames
      }}
      theme={(theme) => ({
        ...theme,
        borderRadius: 0,
        colors: {
          ...theme.colors,
          primary25: "rgba(255, 255, 255, 0.1)",
          primary: "black",
          primary50: "rgba(255, 255, 255, 0.2)"
        }
      })}
      defaultMenuIsOpen={displayAsList}
      value={value}
      styles={styles}
      {...props}
    />
  );
};

StyledReactSelect.propTypes = {
  ...Select.propTypes,
  /** when no option is selected, it will display the options
     as a list, inline with the rest of the page */
  initialDisplayAsList: PropTypes.bool,
  /** remove the height limit for the dropdown list */
  noHeightLimit: PropTypes.bool
};
